/** Fluorescent fitting geometry only; illumination is deliberately a scene concern. */
import * as THREE from 'three';
import { surface } from '../materials';
import type { AssetDefinition } from '../types';

function build(): THREE.Group {
  const group = new THREE.Group();
  group.name = 'ceiling-tube';
  // The workbench's origin checker is deliberately universal, including ceiling
  // pieces. The contact plane is therefore the fixture's ceiling-side mounting
  // face; callers lift this group to the hall ceiling rather than offsetting parts.
  const body = new THREE.Mesh(new THREE.BoxGeometry(0.16, 0.045, 1.5), surface('metal', 0x9da6a8));
  body.name = 'batten-body'; body.position.y = 0.0225; body.castShadow = true;
  const diffuser = new THREE.Mesh(new THREE.BoxGeometry(0.11, 0.026, 1.38), surface('mineral', 0xd8ddd2));
  diffuser.name = 'diffuser'; diffuser.position.y = 0.058; diffuser.castShadow = true;
  const mount = new THREE.Mesh(new THREE.BoxGeometry(0.06, 0.015, 0.18), surface('metal', 0x737d80));
  mount.name = 'ceiling-mount'; mount.position.y = 0.0075;
  group.add(body, diffuser, mount);
  return group;
}

export const ceilingTubeAsset: AssetDefinition = {
  id: 'ceiling-tube', label: 'Ceiling tube', description: '1.5 m fluorescent batten fitting with body and diffuser; no embedded light.',
  footprint: { width: 0.16, height: 0.071, length: 1.5 }, create: build,
};
